import ApiService from './api.service';

export default {
  getCustomerHistory(businessId, customerId) {
    return ApiService.get(`business/${businessId}/customer/${customerId}/history`);
  },
};



// WEBPACK FOOTER //
// ./src/services/customerHistory.service.js